import { render, staticRenderFns } from "./Item000.vue?vue&type=template&id=1a2f148f&"
import script from "./Item000.vue?vue&type=script&lang=js&"
export * from "./Item000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports